import { FieldValues, Path, UseFormReturn } from "react-hook-form";

import { FormDatePickerField } from "../../../../components/forms-design-system/FormDatePickerField";
import { isRequired } from "../../../../helpers/validators";
import { useTranslate } from "../../../../hooks/useTranslate";
import { QuestionOutput } from "../../../../types/trpc";

interface QuestionFieldDateProps<T extends FieldValues> {
  form: UseFormReturn<T>;
  name: Path<T>;
  label: string;
  question: QuestionOutput;
}

export function QuestionFieldDate<T extends FieldValues>({
  name,
  form,
  label,
  question,
  ...rest
}: QuestionFieldDateProps<T>) {
  const { t } = useTranslate();

  return (
    <FormDatePickerField
      label={label}
      data-test="question-field-date"
      required={question.required}
      control={form.control}
      name={name}
      rules={[isRequired(question.required, t("common", "answerRequired"))]}
      {...rest}
    />
  );
}
